import { useMutation } from '@apollo/client';
import { ReplyCascade } from '@nile/banyan/src/Components/Cascades';
import { AccountClient } from '@nile/graphql';
import {
  GET_NOTIFICATION_TEMPLATES,
  DELETE_NOTIFICATION_TEMPLATE
} from '@nile/banyan/src/Graphql/Mutations/templates';
import {
  ContentDeciderContainer,
  toast,
  getTranslatedText,
  AccessControl,
  Loader,
  EventEmitter
} from '@nile/components';
import {
  Page,
  Button,
  TextContainer,
  TextStyle
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import envConfig from '@nile/home/src/Config/env';
import React, { useState, useEffect } from 'react';
import { TEMPLATE_TYPES } from '@nile/banyan/src/Constants/notifications';
import shortid from 'shortid';

import { FormattedMessage, injectIntl } from 'react-intl';

const ReplyCascadeWrapped = ({
  loading,
  templateList = [],
  addOrUpdatePolicy,
  deleteReplyTemplate,
  intl,
  updateSelectedReplyTemplate,
  selectedReplyTemplate,
  isRunbookTemplate,
  editComponent,
  templateType,
  deleteRoleToCheck,
  editRoleToCheck
}) => {
  const updatedList = [...templateList];
  const defaultItemIndex = templateList.findIndex((el) => el?.defaultTemplate);
  const defaultItem = updatedList[defaultItemIndex];

  if (defaultItem) {
    updatedList.splice(defaultItemIndex, 1);
    updatedList.unshift(defaultItem);
  }

  return (
    <div className="full-height">
      <ContentDeciderContainer
        isLoading={loading}
        hasContent={!loading && updatedList && updatedList?.length > 0}
        mainContent={
          <ReplyCascade
            addOrUpdatePolicy={addOrUpdatePolicy}
            deleteReplyTemplate={deleteReplyTemplate}
            data={updatedList || []}
            updateSelectedReplyTemplate={updateSelectedReplyTemplate}
            selectedReplyTemplate={selectedReplyTemplate}
            isRunbookTemplate={isRunbookTemplate}
            editComponent={editComponent}
            templateType={templateType}
            deleteRoleToCheck={deleteRoleToCheck}
            editRoleToCheck={editRoleToCheck}
          />
        }
        fullHeight
        notFoundURL={`${envConfig.imageRoot}svg/not-found.svg`}
        heading={getTranslatedText(intl, 'admin.replyTemplate.emptyState')}
        loadingContent={<Loader />}
      />
    </div>
  );
};

const ReplyContainer = (props) => {
  const {
    intl,
    cascadeOnly,
    updateSelectedReplyTemplate,
    selectedReplyTemplate,
    isRunbookTemplate,
    variables,
    editComponent,
    templateType,
    deleteRoleToCheck,
    editRoleToCheck
  } = props;
  let templateId;
  const [templateList, setTemplateList] = useState([]);
  const [loading, setLoading] = useState(false);

  const getTemplates = () => {
    setLoading(true);
    AccountClient.query({
      query: GET_NOTIFICATION_TEMPLATES,
      variables: variables || {
        notificationTemplateType: TEMPLATE_TYPES.reply
      },
      fetchPolicy: 'network-only'
    })
      .then((res) => {
        if (res?.data?.getNotificationTemplates) {
          setTemplateList(res.data.getNotificationTemplates);
          if (props?.setAllTemplates) {
            props.setAllTemplates(res.data.getNotificationTemplates);
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getTemplates();
    EventEmitter.subscribe('refetchTemplate', getTemplates);
    return function cleanup() {
      EventEmitter.unsubscribe('refetchTemplate');
    };
  }, []);

  const [deleteReplyTemplate] = useMutation(DELETE_NOTIFICATION_TEMPLATE, {
    client: AccountClient,
    onCompleted({ deleteNotificationTemplate }) {
      /* Close sheet container once an employee created */
      if (deleteNotificationTemplate) {
        // toggleActive()
        toast('success', 'Reply template deleted successfully');
        getTemplates();
      }
    },
    onError({ graphQLErrors }) {},
    update(cache, { data }) {
      // let template = cache.readQuery({ query: GET_ALL_REPLYTEMPLATES });
      // let templates = JSON.parse(JSON.stringify(template.getReplyTemplates));
      // const foundIndex = templates.findIndex((item) => {
      //   return item.id == templateId;
      // });
      // templates.splice(foundIndex, 1);
      // console.log(
      //   'CSK templates ',
      //   foundIndex,
      //   template.getReplyTemplates,
      //   templates,
      //   templateId
      // );
      // cache.writeQuery({
      //   query: GET_ALL_REPLYTEMPLATES,
      //   data: { getReplyTemplates: [templates] }
      // });
    }
  });

  function addOrUpdatePolicy(type, slaPolicy) {
    // setSLAPolicy(slaPolicy);
  }

  if (cascadeOnly)
    return (
      <ReplyCascadeWrapped
        loading={loading}
        templateList={templateList}
        addOrUpdatePolicy={addOrUpdatePolicy}
        deleteReplyTemplate={deleteReplyTemplate}
        intl={intl}
        updateSelectedReplyTemplate={updateSelectedReplyTemplate}
        selectedReplyTemplate={selectedReplyTemplate}
        isRunbookTemplate={isRunbookTemplate}
        editComponent={editComponent}
        templateType={templateType}
        deleteRoleToCheck={deleteRoleToCheck}
        editRoleToCheck={editRoleToCheck}
      />
    );

  return (
    <div className="full-height white-grey-page p20 ">
      <Page
        variant="primary"
        contentHeight="120px"
        subtitle={
          <TextContainer>
            <TextStyle variation="subdued">
              <FormattedMessage id="admin.replyTemplates.header.label" />
            </TextStyle>
          </TextContainer>
        }
        title={
          <TextStyle weight="Bold">
            <FormattedMessage id="admin.replyTemplates.header" />
          </TextStyle>
        }
        primaryAction={
          <AccessControl
            roleToCheck="replyTemplate.add"
            render={
              <div data-qa="createBtn" className="fx actr">
                <Button
                  primary
                  url={`#/onboard/reply/${shortid.generate()}/new`}
                  icon={<SVGIcon name="Add" />}
                >
                  <FormattedMessage id="common.create" />
                </Button>
              </div>
            }
          />
        }
      >
        <ReplyCascadeWrapped
          loading={loading}
          templateList={templateList}
          addOrUpdatePolicy={addOrUpdatePolicy}
          deleteReplyTemplate={deleteReplyTemplate}
          intl={intl}
          editComponent={editComponent}
        />
      </Page>
    </div>
  );
};
export default injectIntl(ReplyContainer);
